export default "__VITE_ASSET__Cj3X5tBP__"